import BaseApiClient from "@/api/base-client";
import { useContext } from "@/store/context";
class EventTrackingApi extends BaseApiClient {
    BASE_PATH = "/api/event-tracking";
    logEvent = (eventLog) => {
        const contextStore = useContext();
        const studyId = contextStore.currentStudyId;
        const data = { studyId, ...eventLog };
        return this.post(this.BASE_PATH + "/log", { data: data });
    };
    static instance = new EventTrackingApi();
}
export default EventTrackingApi.instance;
